import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import ServiceAreas from "@/pages/ServiceAreas";
import CityPage from "@/pages/CityPage";
import FAQHub from "@/pages/FAQHub";
import ResourceCenter from "@/pages/ResourceCenter";
import ArticlePage from "@/pages/ArticlePage";
import InsuranceAgents from "@/pages/InsuranceAgents";
import InsuranceClaims from "@/pages/InsuranceClaims";
import CarrierClaimsPage from "@/pages/CarrierClaimsPage";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import HailMap from "@/pages/HailMap";
import RoofReplacement from "@/pages/RoofReplacement";
import StormDamageRestoration from "@/pages/StormDamageRestoration";
import RoofAssessment from "@/pages/RoofAssessment";
import Reviews from "@/pages/Reviews";
import Guides from "@/pages/Guides";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<HomePage />} />
            <Route path="service-areas" element={<ServiceAreas />} />
            <Route path="service-areas/:slug" element={<CityPage />} />
            <Route path="blog" element={<Blog />} />
            <Route path="blog/:slug" element={<BlogPost />} />
            <Route path="resources" element={<ResourceCenter />} />
            <Route path="resources/:slug" element={<ArticlePage />} />
            <Route path="insurance-agents" element={<InsuranceAgents />} />
            <Route path="insurance-claims" element={<InsuranceClaims />} />
            {/* Carrier-specific claim pages */}
            <Route path="state-farm-roof-claims" element={<CarrierClaimsPage carrierSlug="state-farm" />} />
            <Route path="american-family-roof-claims" element={<CarrierClaimsPage carrierSlug="american-family" />} />
            <Route path="allstate-roof-claims" element={<CarrierClaimsPage carrierSlug="allstate" />} />
            <Route path="farmers-roof-claims" element={<CarrierClaimsPage carrierSlug="farmers" />} />
            <Route path="progressive-roof-claims" element={<CarrierClaimsPage carrierSlug="progressive" />} />
            <Route path="liberty-mutual-roof-claims" element={<CarrierClaimsPage carrierSlug="liberty-mutual" />} />
            <Route path="travelers-roof-claims" element={<CarrierClaimsPage carrierSlug="travelers" />} />
            <Route path="usaa-roof-claims" element={<CarrierClaimsPage carrierSlug="usaa" />} />
            <Route path="nationwide-roof-claims" element={<CarrierClaimsPage carrierSlug="nationwide" />} />
            <Route path="auto-owners-roof-claims" element={<CarrierClaimsPage carrierSlug="auto-owners" />} />
            <Route path="western-national-roof-claims" element={<CarrierClaimsPage carrierSlug="western-national" />} />
            <Route path="farm-bureau-roof-claims" element={<CarrierClaimsPage carrierSlug="farm-bureau" />} />
            <Route path="safeco-roof-claims" element={<CarrierClaimsPage carrierSlug="safeco" />} />
            <Route path="hartford-roof-claims" element={<CarrierClaimsPage carrierSlug="hartford" />} />
            <Route path="chubb-roof-claims" element={<CarrierClaimsPage carrierSlug="chubb" />} />
            <Route path="faqs" element={<FAQHub />} />
            <Route path="hail-map" element={<HailMap />} />
            <Route path="roof-replacement" element={<RoofReplacement />} />
            <Route path="storm-damage-restoration" element={<StormDamageRestoration />} />
            <Route path="roof-assessment" element={<RoofAssessment />} />
            <Route path="reviews" element={<Reviews />} />
            <Route path="guides" element={<Guides />} />
            <Route path="privacy-policy" element={<PrivacyPolicy />} />
          </Route>
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
